/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import Tippy from '@tippyjs/react';
import { GroupDetailModal } from 'components/group-detail-modal';
import Box from 'components/ui/box';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext';
import { useEffect, useState } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';
import { BiInfoCircle } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { getRakingByCycle } from 'services/achievement.service';
import { getSeloRealizacao } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';

interface TimelineProps {
  data: any;
  cycle: any;
}

const text = [
  ['Você precisa cadastrar ou participar de ao menos uma Realização Destaque.'],
  [
    'Você precisa cadastrar ou participar de ao menos uma Realização Destaque vinculada ao indicador individual do Conexão, e ela deverá ser validada.',
    'Você precisa cadastrar ou participar de ao menos uma Realização Destaque bonificada na Apreciação Nível 2.',
  ],
  [
    'Você precisa atender aos critérios do Conexão.',
    'Você precisa estar habilitado.',
    'Estar entre os 25% e 40% (inclusive) funcionários com as maiores pontuações do grupo.',
  ],
  [
    'Você precisa atender aos critérios do Conexão.',
    'Você precisa estar habilitado.',
    'Estar entre os 15% e 25% (inclusive) funcionários com as maiores pontuações do grupo.',
  ],
  [
    'Você precisa atender aos critérios do Conexão.',
    'Você precisa estar habilitado.',
    'Estar entre os 5% e 15% (inclusive) funcionários com as maiores pontuações do grupo.',
  ],
  [
    'Você precisa atender aos critérios do Conexão.',
    'Você precisa estar habilitado.',
    'Estar entre os 5% (inclusive) funcionários com as maiores pontuações do grupo.',
  ],
];

const textType = [
  `Caso permaneça nesta faixa no fechamento do ciclo, você terá o seu Valor Referência <b>multiplicado por 0,25</b> como premiação.`,
  `Caso permaneça nesta faixa no fechamento do ciclo, você terá o seu Valor Referência <b>multiplicado por 0,5</b> como premiação.`,
  `Caso permaneça nesta faixa no fechamento do ciclo, você terá o seu Valor Referência <b>multiplicado por 0,75</b> como premiação.`,
  `Caso permaneça nesta faixa no fechamento do ciclo, você terá o seu Valor Referência <b>multiplicado por 1</b> como premiação.`,
];

export default function Timeline({ data, cycle }: TimelineProps) {
  const { userInfo } = useAuth();
  const { showModal } = useModal();

  const [total, setTotal] = useState(0);
  const [time, setTime] = useState<any>();
  const [showInfo, setShowInfo] = useState<any>(false);
  const [timeline, setTimeline] = useState<any[]>([]);
  const [type, setType] = useState<any>();
  const [load, setLoad] = useState(true);
  const [user, setUser] = useState<any>();

  useEffect(() => {
    async function LoadData() {
      if (!userInfo?.chave || !data || !cycle) return;

      setLoad(true);

      const { result } = await getSeloRealizacao('', '', 0, 'realizacoes_premiadas', userInfo?.chave);

      const user = await getPublicProfile(userInfo?.chave, cycle);
      setUser(user);

      setType(user?.type);

      const faixa = result[0]?.faixa;

      let _total = 0;
      data?.forEach((item: any) => {
        _total += item.total;
      });

      setTotal(_total);

      const _timeline = [];

      const isHabilited = data?.find((item: any) => item.multiplicador >= 4);

      _timeline.push(
        {
          title: 'Cadastrado',
          completed: data?.length > 0,
        },
        {
          title: 'Habilitado',
          completed: isHabilited,
        },
        {
          title: 'Faixa 4',
          completed: isHabilited && faixa <= 4,
          sub: {
            completed: isHabilited && faixa <= 4,
          },
        },
        {
          title: 'Faixa 3',
          completed: isHabilited && faixa <= 3,
          sub: { completed: isHabilited && faixa <= 3 },
        },
        {
          title: 'Faixa 2',
          completed: isHabilited && faixa <= 2,
          sub: { completed: isHabilited && faixa <= 2 },
        },
        {
          title: 'Faixa 1',
          completed: isHabilited && faixa <= 1,
          sub: { completed: isHabilited && faixa <= 1 },
        },
      );

      setTimeline(_timeline);
      setLoad(false);
    }

    if (cycle && userInfo && data) {
      LoadData();
    }
  }, [data, cycle, userInfo]);

  function formatNumber(num: number): string {
    return num.toLocaleString('pt-BR');
  }

  function calcPosition(total: number, position: number) {
    const porcentagens = [0.05, 0.15, 0.25, 0.4];
    let resultados: any = [];

    for (let i = 0; i < porcentagens.length; i++) {
      const somaPorcentagens = porcentagens.slice(0, i + 1).reduce((a, b) => a + b, 0);
      const somaResultados: any = resultados.reduce((a: number, b: number) => a + b, 0);
      const resultado = Math.ceil(total * somaPorcentagens) - somaResultados;
      resultados.push(resultado <= 0 ? 0 : resultado);
    }

    resultados = resultados.map((e: number, index: number) => {
      if (index === 0) {
        return e;
      } else if (index === 1) {
        return e + resultados[index - 1];
      } else if (index === 2) {
        return e + resultados[index - 1] + resultados[index - 2];
      } else if (index === 3) {
        return e + resultados[index - 1] + resultados[index - 2] + resultados[index - 3];
      }

      return e;
    });

    let result = undefined;

    if (resultados[3] >= position) {
      result = 40;
    }

    if (resultados[2] >= position) {
      result = 25;
    }

    if (resultados[1] >= position) {
      result = 15;
    }

    if (resultados[0] >= position) {
      result = 5;
    }

    return result;
  }

  if (!type || type === 'PREDEFINIDO' || load) return <></>;

  return (
    <>
      <Box>
        <div className="mb-10">
          <h2
            className="font-bold text-[22px] leading-none flex items-center cursor-pointer"
            onClick={() => showModal('group-detail')}
          >
            Acompanhe o status de premiação por seu grupo <BiInfoCircle className="relative ml-1" />{' '}
          </h2>
          <p className="text-lg leading-none mt-4">
            Pontos de realizações: <span className="text-yellow">{formatNumber(total)}</span>{' '}
            {time && <span className="font-thin text-xs text-blue-100">Atualizado em: {time}</span>}
          </p>
        </div>

        <div className="md:flex justify-between md:space-x-12 mb-8 mt-1">
          {timeline.map((item, index) => (
            <div key={item.title} className="flex-1 w-full flex flex-col">
              <p className="flex items-center space-x-1 text-xs leading-none font-light mb-4 h-[18px]">
                <Tippy
                  arrow={true}
                  className="bg-black text-white"
                  allowHTML={true}
                  content={
                    index > 1 ? <div className="font-thin" dangerouslySetInnerHTML={{ __html: textType[index - 2] }} /> : null
                  }
                  disabled={index <= 1}
                >
                  <span
                    className={`flex items-center ${
                      ((item.completed && item?.sub?.completed) || (item.completed && !item.sub)) && 'text-[#04D475]'
                    }`}
                  >
                    {item.title} {index > 1 && <BiInfoCircle className="relative ml-1" size={18} />}
                  </span>
                </Tippy>
              </p>

              <div className="flex justify-between items-stretch h-[10px] rounded-lg overflow-hidden mb-3">
                <Tippy arrow={true} className="bg-black text-white" content="Critérios do JogaJunto BB">
                  <span className={`flex-1 w-full block h-full ${item.completed ? 'bg-[#04D475]' : 'bg-[#C7D3EB]'}`}>
                    {item.completed && <FaCheck className="text-oxford-blue mx-auto" size={11} />}
                  </span>
                </Tippy>
                {item?.sub && (
                  <>
                    <span className="w-[1px] block h-full"></span>
                    <Tippy arrow={true} className="bg-black text-white" content="Critérios do Conexão">
                      <span className={`flex-1 w-full block h-full ${item?.sub?.completed ? 'bg-[#04D475]' : 'bg-[#C7D3EB]'}`}>
                        {item?.sub?.completed && <FaCheck className="text-oxford-blue mx-auto" size={11} />}
                      </span>
                    </Tippy>
                  </>
                )}
              </div>

              <button className="uppercase text-grey-dark" onClick={() => setShowInfo(index)}>
                ver critérios
              </button>
            </div>
          ))}
        </div>

        <div className="text-yellow flex items-start space-x-2 mt-5">
          <AiOutlineWarning size={60} />
          <p className="text-white font-thin">
            <b>Atenção:</b> O status da sua premiação poderá mudar conforme as realizações cadastradas por você e pelos demais
            funcionários do grupo que você está inserido. Continue cadastrando e participando de realizações destaque nas demais
            fases deste ciclo para permanecer ou avançar para as demais faixas.{' '}
            <b>
              Fique atento! As barras das faixas 1, 2 , 3 e 4 só serão preenchidas completamente ao final do ciclo, após o
              fechamento do Conexão.
            </b>
            <a
              href="https://plataforma.atendimento.bb.com.br:49286/estatico/gaw/app/spas/index/index.app.html?app=atbConexaoJornadaUnica#/"
              target="_blank"
              className="underline ml-2 active:text-white visited:text-white hover:text-white"
              rel="noreferrer"
            >
              Saiba como atender aos requisitos do Conexão.
            </a>
          </p>
        </div>
      </Box>

      {user && (
        <GroupDetailModal
          group={{
            ...user.grupo,
          }}
        />
      )}

      {showInfo !== false && (
        <div className="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center">
          <Box className="relative bg-oxford-blue border-electric-blue p-1 lg:p-8 flex flex-col w-[90%] lg:w-auto lg:max-w-[400px]  justify-center items-center border-opacity-100 bg-opacity-100">
            <Button
              color="primary"
              className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
              onClick={() => setShowInfo(false)}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <div className="space-y-3">
              <h1 className="text-yellow text-lg mb-4">
                Entenda os critérios para integrar esta {showInfo <= 1 ? 'etapa' : 'faixa'}:
              </h1>

              <ol className="list-decimal ml-4">
                {text[showInfo]?.map((item: string) => (
                  <li key={item} className="text-left mb-2">
                    {item}
                  </li>
                ))}
              </ol>
            </div>
          </Box>
        </div>
      )}
    </>
  );
}
